// extracted by mini-css-extract-plugin
module.exports = {"b2bPartnersSection":"_3dyF_tp6KymTCo0dJHLYlq"};